module.exports = __webpack_public_path__ + "static/media/Left legs24.9777ae6d.png";